/**
 * Parts API (/api/v1/parts)
 */

import { apiGet, apiPost } from "./client";
import {
  Part,
  PartCreateRequest,
  PartListParams,
  PartListResponse,
} from "./types";

export function listParts(params?: PartListParams): Promise<PartListResponse> {
  return apiGet<PartListResponse>("/parts", params);
}

/** Create a part (progressive Add-part form). Requires ADMIN/MANAGER. */
export function createPart(payload: PartCreateRequest): Promise<Part> {
  return apiPost<Part>("/parts", payload);
}

export function getPart(id: number | string): Promise<Part> {
  return apiGet<Part>(`/parts/${id}`);
}

export function getPartByBarcode(barcode: string): Promise<Part> {
  return apiGet<Part>(`/parts/barcode/${encodeURIComponent(barcode)}`);
}
